/*@ngInject*/
const FilesAndIconsManagerActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function () {
        const url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.configuredfile.ConfiguredFile:null'
                }
            };

        return this.get(url, config);
    };
};

angular.module('ums.configuration')
    .service('filesAndIconsManagerActionRepository', FilesAndIconsManagerActionRepository);
